const CONJUNCTION_BY_LOCALE: Record<string, string> = {
  en: 'and',
  fi: 'ja',
  sv: 'och',
};

function normalizeLocale(locale?: string): 'en' | 'fi' | 'sv' {
  const base = (locale ?? 'en').toLowerCase().split('-')[0];
  if (base === 'fi' || base === 'sv') return base;
  return 'en';
}

function uniqueNonEmpty(values: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const raw of values) {
    const value = raw.trim();
    if (!value) continue;
    const key = value.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    result.push(value);
  }
  return result;
}

export function formatCompanyInsightLocationList(
  locations: string[],
  locale?: string,
  maxItems = 3,
): string {
  const normalized = uniqueNonEmpty(locations).slice(0, maxItems);
  if (normalized.length === 0) return '';
  if (normalized.length === 1) return normalized[0];

  const conjunction = CONJUNCTION_BY_LOCALE[normalizeLocale(locale)];
  if (normalized.length === 2) {
    return `${normalized[0]} ${conjunction} ${normalized[1]}`;
  }

  const head = normalized.slice(0, -1).join(', ');
  const tail = normalized[normalized.length - 1];
  return `${head}, ${conjunction} ${tail}`;
}

